// import dash from '../svg/dashboard.svg'

export default function Grafica() {
  return (
    <div className="min-h-screen flex flex-col items-center py-20 px-8">
      {/* Encabezado */}
      <div className="text-center mb-16 max-w-4xl">
        <h1 className="text-black font-extrabold text-4xl lg:text-5xl mb-6 text-[#000]">
          Todo lo que tu empresa necesita
        </h1>
        <p className="text-gray-600 text-lg lg:text-xl">
          Descubre la solución completa que tu empresa merece y eleva tu paquetería al siguiente nivel.
        </p>
      </div>

      {/* Contenido */}
      <div className="w-full max-w-7xl">
        {/* Listado de características */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Cada característica con icono */}
          {[
            {
              icon: (
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto">
                  {/* Fondo rojo difuminado en forma cuadrada */}
                  <div className="absolute w-14 h-14 bg-[#ea1300] rounded-md opacity-80"></div>
                  {/* Ícono blanco encima */}
                  <div className="relative z-10 flex items-center justify-center w-12 h-12">
                    <span className="material-symbols-outlined text-white text-4xl">hub</span>
                  </div>
                </div>
              ),
              title: 'Crea Guías Digitales',
              text: 'Crea guías y multiguias digitales rápido y fácil. Organiza y escanea tus envíos con nuestro lector de códigos integrado, sin perder tiempo.'
            },
            {
              icon: (
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto">
                  <div className="absolute w-14 h-14 bg-[#ea1300] rounded-md opacity-80"></div>
                  <div className="relative z-10 flex items-center justify-center w-12 h-12">
                    <span className="material-symbols-outlined text-white text-4xl">delivery_truck_speed</span>
                  </div>
                </div>
              ),
              title: 'Asignación de Rutas',
              text: 'Asigna transportistas y rutas en segundos. Entregas más rápidas, menos gasolina y mayor eficiencia.'
            },
            {
              icon: (
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto">
                  <div className="absolute w-14 h-14 bg-[#ea1300] rounded-md opacity-80"></div>
                  <div className="relative z-10 flex items-center justify-center w-12 h-12">
                    <span className="material-symbols-outlined text-white text-4xl">clinical_notes</span>
                  </div>
                </div>
              ),
              title: 'Carta Porte Automática',
              text: 'Genera tu carta porte al instante, sin errores ni plataformas externas. Cumple con SAT y sigue operando sin complicaciones.'
            },
            {
              icon: (
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto">
                  <div className="absolute w-14 h-14 bg-[#ea1300] rounded-md opacity-80"></div>
                  <div className="relative z-10 flex items-center justify-center w-12 h-12">
                    <span className="material-symbols-outlined text-white text-4xl">conversion_path</span>
                  </div>
                </div>
              ),
              title: 'Seguimiento Total',
              text: 'Sigue cada envío en tiempo real, desde la recolección hasta la entrega. Más control, menos llamadas y reclamos.'
            },
            {
              icon: (
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto">
                  <div className="absolute w-14 h-14 bg-[#ea1300] rounded-md opacity-80"></div>
                  <div className="relative z-10 flex items-center justify-center w-12 h-12">
                    <span className="material-symbols-outlined text-white text-4xl">monitoring</span>
                  </div>
                </div>
              ),
              title: 'Métricas al Instante',
              text: 'Accede a reportes y métricas clave para mejorar tu operación y tomar decisiones inteligentes.'
            },
            {
              icon: (
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto">
                  <div className="absolute w-14 h-14 bg-[#ea1300] rounded-md opacity-80"></div>
                  <div className="relative z-10 flex items-center justify-center w-12 h-12">
                    <span className="material-symbols-outlined text-white text-4xl">qr_code_scanner</span>
                  </div>
                </div>
              ),
              title: 'Cara a Cliente',
              text: 'Permite que tus clientes consulten envíos, soliciten servicios y actualicen su información, sin saturar tu equipo.'
            }
          ].map((feature, index) => (
            <div key={index} className="flex flex-col items-center text-center p-6">
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-red-600 font-bold text-xl mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}